import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DigitalSignEventsService} from '@shared/components/core-sign/services/digital-sign-events.service';
import {Subscription} from 'rxjs';
import {DossierType, SignersType} from '@shared/components/core-sign/models/enums.model';
import {DigitalSignOperatorStartedProcess, DigitalSignStartedCustomerProcess} from '@shared/components/core-sign/models/digital-signer.model';
import {LoaderService} from '@shared/service/loader.service';
import {DigitalSignClauses} from '../../../../../digital-sign/models/digital-sign-clauses';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-procedure',
	templateUrl: './digital-sign-procedure.component.html',
	styleUrls: ['./digital-sign-procedure.component.scss']
})
export class DigitalSignProcedureComponent implements OnInit, OnDestroy {
	@Input() module: string;

	procedure_state: number = 0;
	operatorSignedDocuments: any[] = [];
	operator_procedure_state: number = 0;
	customer_procedure_state: number = 0;
	operatorToken: string;
	dsStartedOperatorProcess: DigitalSignOperatorStartedProcess;
	dsStartedCustomerProcess: DigitalSignStartedCustomerProcess;
	dsStartedCustomerCertificateProcess: DigitalSignOperatorStartedProcess;
	customerToken: string;
	private getCreatedDossierForSignerSubscription: Subscription;
	private operatorGoToNextStepSubscription: Subscription;
	private procedureGoToNextStepSubscription: Subscription;
	private nextStepCustomerSubscription: Subscription;
	translateContext = TranslateContext;

	constructor(
		private digitalSignEventsService: DigitalSignEventsService,
		private loaderService: LoaderService
	) {
	}

	ngOnInit(): void {
		this.digitalSignEventsService.createDossierForSignerSubject.next({
			dossier_type: DossierType.LAST,
			sign_type: SignersType.OPERATOR
		});

		this.getCreatedDossierForSignerSubscription =
			this.digitalSignEventsService.getCreatedDossierForSignerObservable.subscribe(createdDossier => {

				if (createdDossier === null) {
					this.digitalSignEventsService.createDossierForSignerSubject.next({
						dossier_type: DossierType.START,
						sign_type: SignersType.OPERATOR
					});
					return;
				}
				switch (createdDossier.signer_type) {
					case SignersType.OPERATOR:
						switch (createdDossier.dossier_type) {
							case DossierType.COMPLETE:
								this.operatorToken = createdDossier.token;
								this.dsStartedOperatorProcess = new DigitalSignOperatorStartedProcess(createdDossier.dossier);
								break;
							case DossierType.SIGN:
								if (!!createdDossier.dossier && !!createdDossier.dossier.signatures && !!createdDossier.dossier.signatures.documents) {
									this.operatorSignedDocuments = createdDossier.dossier.signatures.documents;
								}
								break;
						}
						break;
					case SignersType.CUSTOMER:
						switch (createdDossier.dossier_type) {
							case DossierType.START:
								this.customerToken = createdDossier.token;
								this.dsStartedCustomerProcess = new DigitalSignStartedCustomerProcess(createdDossier.dossier);
								break;
							case DossierType.COMPLETE:
								this.dsStartedCustomerCertificateProcess = new DigitalSignOperatorStartedProcess(createdDossier.dossier);
								break;
						}
						break;
				}
				this.loaderService.display(false);
			});

		this.operatorGoToNextStepSubscription =
			this.digitalSignEventsService.nextStepOperatorObservable.subscribe(value => this.onChangeOperatorProcedureState(value));

		this.procedureGoToNextStepSubscription =
			this.digitalSignEventsService.procedureGoToNextStepObservable.subscribe(value => this.onChangeProcedureState(value));

		this.nextStepCustomerSubscription =
			this.digitalSignEventsService.nextStepCustomerObservable.subscribe(value => this.onChangeCustomerProcedureState(value.value, value.body));
	}

	ngOnDestroy(): void {
		if (!!this.getCreatedDossierForSignerSubscription) {
			this.getCreatedDossierForSignerSubscription.unsubscribe();
		}
		if (!!this.operatorGoToNextStepSubscription) {
			this.operatorGoToNextStepSubscription.unsubscribe();
		}
		if (!!this.procedureGoToNextStepSubscription) {
			this.procedureGoToNextStepSubscription.unsubscribe();
		}
		if (!!this.nextStepCustomerSubscription) {
			this.nextStepCustomerSubscription.unsubscribe();
		}
	}

	onChangeProcedureState(event: boolean): void {
		this.procedure_state = event ? 1 : 0;
		if (this.procedure_state === 1) {
			this.digitalSignEventsService.createDossierForSignerSubject.next({
				sign_type: SignersType.CUSTOMER,
				dossier_type: DossierType.START
			});
		}
	}

	onChangeOperatorProcedureState(event: boolean): void {
		this.operator_procedure_state = event ? 1 : 0;
	}

	onChangeCustomerProcedureState(event: boolean, body: DigitalSignClauses ): void {
		this.customer_procedure_state = event ? 1 : 0;
		if (this.customer_procedure_state === 1) {
			this.digitalSignEventsService.createDossierForSignerSubject.next({
				sign_type: SignersType.CUSTOMER,
				dossier_type: DossierType.COMPLETE,
				body: body
			});
		}
	}
}
